import { defineStore } from 'pinia';
import * as api from '../utils/api';

export const useWebsiteStore = defineStore('websiteStore', {
  state: () => ({
    userInfo: null,
    symbols: null,
    isCookieConsentVisible: false,
  }),
  actions: {
    async loadUserInfo() {
      try {
        this.userInfo = await api.getMyProfile();
      } catch (e) {
        console.error(e);
        // noop
      }
    },
    async loadGlobalData() {
      // Load symbols
      if (!this.symbols) {
        const { data: symbols } = await useAsyncData(() => api.getSymbols());
        this.symbols = symbols.value;
      }
    },
    showCookieConsent() {
      this.isCookieConsentVisible = true;
    },
    hideCookieConsent() {
      this.isCookieConsentVisible = false;
    },
  },
});
